import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { RotatingSquare } from "react-loader-spinner";
import { AuthContext } from "../../../../../Contexts/AuthContext/AuthProvider";
import axios from "axios";
import OrderSetAssignedView from "./OrderSetAssignedView/OrderSetAssignedView";

const OrderSetAssign = () => {
    const { authUser } = useContext(AuthContext);
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [OrderSetData, setOrderSetData] = useState([]);


    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/order-set/all/view`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setOrderSetData(data.data);
                setLoading(false);
            });
    }, []);


    const [result, setResult] = useState([]);

    const refSubmitDis = useRef();
    const [errorMessage, setErrorMessage] = useState({});
    const [orderSetId, setOrderSetId] = useState("");

    const handleSubmitData = async (event) => {
        event.preventDefault();

        if (!refSubmitDis.current) return;
        refSubmitDis.current.disabled = true;
        setErrorMessage({});
        const storeData = {
            userId: id,
            orderSetId: orderSetId,
        };

        try {
            const response = await axios.post(
                "https://api.velormall.com/api/admin/order-set/assign/create",
                storeData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response?.data?.success) {
                event.target.reset();
                setOrderSetId("");
                toast.success(response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    theme: "colored",
                });
                setResult(response?.data);
            } else {
                toast.error(response?.data?.message || "Assignment failed");
            }
        } catch (error) {
            setErrorMessage(error?.response?.data?.errors || {});
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message,
                    {
                        position: "top-right",
                        autoClose: 5000,
                        theme: "colored",
                    }
                );
            }

        } finally {
            if (refSubmitDis.current) {
                refSubmitDis.current.disabled = false;
            }
        }
    };



    return (

        <>

            <div className="card mt-30">
                <div className="card-header">
                    <h5 className="card-title mb-0">
                        Order Set Assign
                    </h5>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmitData}>


                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="role" className="required">Order Set </label>
                                    <select className="form-control" name="" id="role"
                                        value={orderSetId}
                                        onChange={(e) =>
                                            setOrderSetId(e.target.value)
                                        }
                                        disabled={loading}
                                    >
                                        <option value="" disabled selected>Select Order Set </option>
                                        {OrderSetData.map((item) => (
                                            <option key={item?._id} value={item?._id}>
                                                {item?.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errorMessage?.orderSetId && (
                                        <span className="text-danger pt-2">
                                            {errorMessage?.orderSetId?.msg}
                                        </span>
                                    )}
                                </div>
                            </div>

                        </div>


                        <div className="row mt-4">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <button
                                        type="submit"
                                        ref={refSubmitDis}
                                        className="btn btn-primary w-100 h-45"
                                    >
                                        Assign
                                    </button>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </div>

            <OrderSetAssignedView result={result} />

        </>

    );

};

export default OrderSetAssign;
